export default __webpack_public_path__ + "static/media/digitalmarketing.eed762ac.svg";